import React, { useEffect, useState } from 'react';
import { IoCardOutline, IoFlashOutline, IoMailOutline, IoShieldOutline } from 'react-icons/io5';
import { useContextHook } from 'use-context-hook';
import authService from '../services/authService';
import Toast from '../components/molecules/Toast';
import { setCookie } from '../helpers/common';
import OtpInput from '../components/atoms/Otp';
import Button from '../components/molecules/Button';
import OnboardingTemplate from '../components/atoms/OnboardingTemplate';
import { AuthFormShell } from '../components/atoms/Onboarding/AuthForm.styles';
import {
  ResendText,
  TrustBadge,
  TrustGrid,
  VerifyIconWrap,
} from '../components/atoms/Onboarding/Onboarding.styles';
import { AuthContext } from '../Context/authContext';

const trustItems = [
  { icon: IoShieldOutline, label: 'Secure verification' },
  { icon: IoFlashOutline, label: 'Takes less than 10 seconds' },
  { icon: IoCardOutline, label: 'No credit card required' },
];

function Verifyotp() {
  const [email, setEmail] = useState('');
  const [otpValue, setOtpValue] = useState([]);
  const [loading, setLoading] = useState(false);
  const [OTPError, setOTPError] = useState(false);

  const { getPermissions } = useContextHook(AuthContext, v => ({
    getPermissions: v.getPermissions,
  }));

  useEffect(() => {
    const localMail = localStorage.getItem('email');
    setEmail(localMail || '');
  }, []);

  async function handelVerifyOtp() {
    const otp_code = otpValue.join('');
    if (otp_code.length < 4) {
      setOTPError(true);
      return;
    }

    setLoading(true);
    const payload = {
      email,
      otp: otp_code,
    };

    try {
      const resp = await authService.verify(payload);
      if (resp.success) {
        Toast({
          type: 'success',
          message: resp.message,
        });
        setCookie(process.env.REACT_APP_AI_TOKEN_COOKIE, resp?.data?.token);
        setCookie(process.env.REACT_APP_AI_STATUS_COOKIE, resp?.data?.status);
        await getPermissions();
        setOtpValue(new Array(4).fill(''));
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error?.message || 'Otp is Expired',
      });
    } finally {
      setLoading(false);
    }
  }

  async function handelResend() {
    try {
      const resp = await authService.sendOtp({ email });
      if (resp.message) {
        Toast({
          type: 'info',
          message: resp.message,
        });
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message,
      });
    }
  }

  return (
    <OnboardingTemplate>
      <AuthFormShell $centered>
        <VerifyIconWrap>
          <IoMailOutline />
        </VerifyIconWrap>

        <div className="auth-heading">
          <h1>Check your inbox</h1>
          <p>We sent a 4-digit code to {email || 'your email'}. Enter it below to continue.</p>
        </div>

        <OtpInput
          width="280px"
          numInputs={4}
          setOtpValue={value => setOtpValue(value)}
          otpValue={otpValue}
          handleResentOtp={handelResend}
          OTPError={OTPError}
          setOTPError={setOTPError}
        />

        <div className="btn-holder">
          <Button width="100%" loader={loading} onClick={handelVerifyOtp} disabled={loading} variant="onboarding-gradient">
            Continue
          </Button>
        </div>

        <ResendText>
          Didn&apos;t get it? <button type="button" onClick={handelResend}>Resend code</button>
        </ResendText>

        <TrustGrid>
          {trustItems.map(item => (
            <TrustBadge key={item.label}>
              <item.icon />
              {item.label}
            </TrustBadge>
          ))}
        </TrustGrid>
      </AuthFormShell>
    </OnboardingTemplate>
  );
}

export default Verifyotp;
